import { getField, updateField } from 'vuex-map-fields'

const initialState = () => ({
  paciente: {},
  agendamento: {},
  responsavelAtendimento: {},
  dadosContato: {},
  idEspecialidade: null,
  idLocal: null,
  idAgenda: '',
  localAtendimento: null,
  local: null,
  sucessoAgendamento: null,
  especialidadeDescricao: '',
  tipoServico: [],
  idServico: null,
  listaLocal: []
})

const state = initialState

const getters = {
  getField,
  paciente: state => state.paciente,
  responsavelAtendimento: state => state.responsavelAtendimento,
  dadosContato: state => state.dadosContato,
  especialidadeDescricao: state => state.especialidadeDescricao,
  tipoServico: state => state.tipoServico,
  idServico: state => state.idServico,
  idEspecialidade: state => state.idEspecialidade
}

const actions = {
  setPaciente ({ commit }, paciente) {
    commit('SET_PACIENTE', paciente)
  },
  setIdEpecialidade ({ commit }, id) {
    commit('SET_ID_ESPECIALIDADE', id)
  },
  setIdLocal ({ commit }, id) {
    commit('SET_ID_LOCAL', id)
  },
  setIdAgenda ({ commit }, id) {
    commit('SET_ID_AGENDA', id)
  },
  setAgendamento ({ commit }, data) {
    commit('SET_AGENDAMENTO', data)
  },
  setLocalAtendimento ({ commit }, data) {
    commit('SET_LOCAL', data)
  },
  setAgendamentoSucessso ({ commit }, data) {
    commit('SET_AGENDAMENTO_SUCESSO', data)
  },
  setResponsavelAtendimento ({ commit }, responsavelAtendimento) {
    commit('SET_RESPONSAVEL_ATENDIMENTO', responsavelAtendimento)
  },
  setDadosContato ({ commit }, dadosContato) {
    commit('SET_DADOS_CONTRATO', dadosContato)
  },
  setEspecialidadeDescricao ({ commit }, data) {
    commit('SET_ESPECIALIDADE_DESCRICAO', data)
  },
  setTipoServico ({ commit }, data) {
    commit('SET_TIPO_SERVICO', data)
  },
  setIdServico ({ commit }, id) {
    commit('SET_ID_SERVICO', id)
  }
}

const mutations = {
  updateField,
  SET_PACIENTE (state, paciente) {
    state.paciente = paciente
  },
  SET_ID_ESPECIALIDADE (state, id) {
    state.idEspecialidade = id
  },
  SET_ID_LOCAL (state, id) {
    state.idLocal = id
  },
  SET_LOCAL (state, data) {
    state.local = data
  },
  SET_LISTA_LOCAL (state, data) {
    state.listaLocal = data
  },
  SET_ID_AGENDA (state, id) {
    state.idAgenda = id
  },
  SET_AGENDAMENTO (state, data) {
    state.agendamento = data
  },
  SET_AGENDAMENTO_SUCESSO (state, data) {
    state.sucessoAgendamento = data
  },
  SET_RESPONSAVEL_ATENDIMENTO (state, responsavelAtendimento) {
    state.responsavelAtendimento = responsavelAtendimento
  },
  SET_DADOS_CONTRATO (state, dadosContato) {
    state.dadosContato = dadosContato
  },
  SET_ESPECIALIDADE_DESCRICAO (state, data) {
    state.especialidadeDescricao = data
  },
  SET_TIPO_SERVICO (state, data) {
    state.tipoServico = data
  },
  SET_ID_SERVICO (state, id) {
    state.idServico = id
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
